import * as React from 'react'
import { track } from '../utils/analytics'

/**
 * Trigers pixel and mixpanel events on load. Used for tracking when new screens
 * load (e.g. UberPhone, Generating).
 */
export const useScreenTracking = (
  pixelEvent: string,
  mixpanelEvent: string
): void => {
  React.useEffect(() => {
    track(pixelEvent, mixpanelEvent)
  }, [])
}
